// extracted by mini-css-extract-plugin
export default {"spinner":"CustomSpinner_spinner__GviOy","spinner-dash":"CustomSpinner_spinner-dash__8GgnV"};